(() => {
  angular
    .module('app.ics')
    .controller('SamplingController', Sampling);

  Sampling.$inject = [
    '$scope',
    '$window',
    '$timeout',
    'Interceptions',
    'ModalService',
    'CampaignService',
  ];

    function Sampling(
      $scope,
      $window,
      $timeout,
      Interceptions,
      ModalService,
      CampaignService,
    ) {
      const vm = this;

      vm.saveDisabled = false;

      vm.dataValid = false;
      vm.checkingUrl = false;
      vm.changed = false;
      vm.redirected = false;

      $scope.isUrlValid = false;

      vm.loaded = false;

      vm.isEdit = /\/ics\/sampling\/\d+/.test($window.location.pathname);

      var stepsAvailable = ['survey', 'target', 'confirmation'];
      if (window.ICS_CONFIG.sampleId > 0){
        stepsAvailable = ['survey', 'target'];
      }

      function isTipUnderstood(){
        return window.localStorage.getItem("didYouSeeTip") == "yeap";
      }

      function setTipUnderstood(){
        window.localStorage.setItem("didYouSeeTip", "yeap");
      }

      vm.openModalTip = function(){
        ModalService
          .showModal(({
            templateUrl:"../../assets/js/app/interception/modal/audienceTip.html",
            controller:"TipController",
            controllerAs:"tipa"
          })).then(function(modal){
            modal.element.modal();
            modal.close.then(function (result) {
              if (result){
                setTipUnderstood();
              }
            });
          });
      };

      vm.showedTipOnce = false;

      vm.showAudienceExplanationPopup = function() {
        if (!isTipUnderstood() && vm.showedTipOnce == false){
          vm.showedTipOnce = true;
          vm.openModalTip();
        }
      };

      vm.step = {
        steps: stepsAvailable,
        current: 0,
        hasPrev: function () {
          return this.current != 0;
        },
        hasNext: function () {
          return this.current != this.steps.length - 1;
        },
        prev: function () {
          this.current--;
          $window.location.hash = this.steps[this.current];
        },
        next: function () {
          this.current++;
          $window.location.hash = this.steps[this.current];
        },
        goTo: function (num) {
          $window.location.hash = this.steps[num];
        },
        init: function () {
          if ($window.location.hash){
            var currentStepName = _.find(this.steps, function(item) { return $window.location.hash.indexOf(item) >= 0; });
            this.current = _.indexOf(this.steps, currentStepName);
            if (this.current == -1) {
              this.goTo(0);
            } else{
              vm.showAudienceExplanationPopup();
            }
          }

          return this;
        }
      }.init(); // initialize the step

      // support for backward and forward button
      $(window).on('hashchange', function () {
        vm.step.init();
        $scope.$digest();
      });


      $scope.exposeContainer = {
        value: [0,1,2,3,4,5,6,7,8,9,10],
        selectedValue: 50,
        inside: 0,
        outside: 100,
        progress: {
          exposed: 0,
          notExposed: 0,
          total: 0
        }
      };

      $scope.interception = {
        id: null,
        name: '',
        surveyUrl: '',
        participantsCount: '',
        percentOfExposed: 50,

        startType: 0,
        codes: [],
        isAllChecked: false,

        anySelected: function(){
          return _.some($scope.interception.codes, function(c) {return c.checked;})
        },

        toggleAll: function(){
          var isAllChecked = _.all($scope.interception.codes, function(c) {return c.checked; });
          _.each($scope.interception.codes, function(c) {c.checked = !isAllChecked});
        },

        deleteSelected: function(){
          $scope.interception.codes = _.filter($scope.interception.codes, function(c) { return !c.checked;});
        }
    };

    $scope.origInterception = angular.copy($scope.interception);

    vm.numPattern = "[1-9][0-9]?[0-9]?[0-9]?";

    var urlCheck = null;

    $scope.$watch(() => $scope.interception.surveyUrl,
      newValue => {
        vm.checkingUrl = true;
        if (urlCheck != null) {
          urlCheck.abort();
        }

        urlCheck = $.ajax({
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          headers: { 'Authorization': `Bearer ${window.ICS_CONFIG.token}` },
          url: `https://${window.ICS_CONFIG.host}/interception/checkUrl`,
          data: JSON.stringify(newValue)
        });

        urlCheck.done(response => {
          var resp = angular.fromJson(response);
          $timeout(() => {
            $scope.isUrlValid = resp && resp.urlValid == true;
            vm.checkingUrl = false;
            vm.validate($scope.interception);
          }, 0);
        });

        urlCheck.fail(() => {
          $timeout(() => {
            $scope.isUrlValid = false;
            vm.checkingUrl = false;
            vm.dataValid = false;
          }, 0);
        });
      }, true);

    vm.checkIfStringValid = function(value) {
      return value != null && value != undefined && value.length > 0;
    }

    $scope.$watch(function() {
      return $scope.interception.codes;
    }, function (newValue) {
      $scope.interception.isAllChecked = _.all(newValue, function(c) {return c.checked;});
    }, true);

    $scope.$watch(function() {
      return $scope.interception;
    }, function (newValue) {
      vm.validate(newValue);
      vm.invalidateInOutCounts(newValue.participantsCount, $scope.exposeContainer.value);
    }, true);

    vm.invalidateInOutCounts = function(participantsCount, insidePercent) {
      $scope.exposeContainer.selectedValue = insidePercent[insidePercent.length-1] * 5;

      var count = parseInt(participantsCount + '');
      if (isNaN(count)){
        count = 100;
      }
      if (count >= 0) {
        var leftCount = count - $scope.exposeContainer.progress.total;
        if (leftCount < 0) {
          leftCount = 0
        }
        var normalized = $scope.exposeContainer.selectedValue / 100.0;
        $scope.exposeContainer.inside = $scope.exposeContainer.progress.exposed + Math.round(normalized * leftCount);
        $scope.exposeContainer.outside = $scope.exposeContainer.progress.notExposed + Math.round((1 - normalized) * leftCount);
      }

      if (insidePercent[0] > 0){
        $scope.exposeContainer.value = _.range(insidePercent[0] + 1);
      }
    }

    $scope.$watch(function() {
      return $scope.exposeContainer.value;
    }, function (newValue) {
      vm.invalidateInOutCounts($scope.interception.participantsCount, newValue);
    }, true);

    vm.validate = function(newValue){
      vm.dataValid =  $scope.isUrlValid
        && vm.checkIfStringValid(newValue.name)
        && (parseInt(newValue.participantsCount + '') > 0)
        && (parseInt(newValue.participantsCount + '') <= 9999);
    };

    var loadInterception = function(){
      Interceptions.get({id: window.ICS_CONFIG.sampleId}, {}, function(model){
        var intModel = model.interception;
        var progress = model.progress;
        console.log(JSON.parse(intModel.campaigns));

        $scope.interception.id = intModel.id;
        $scope.interception.name = intModel.name;
        $scope.interception.startType = intModel.startType;
        $scope.interception.surveyUrl = intModel.surveyUrl;
        $scope.interception.participantsCount = intModel.requiredStartsCount;
        $scope.interception.percentOfExposed = intModel.percentOfExposed;
        $scope.interception.dailyInvitationLimit = intModel.dailyInvitationLimit;
        $scope.interception.codes = JSON.parse(intModel.campaigns);
        $scope.isUrlValid = true;
        $scope.origInterception = angular.copy($scope.interception);

        $scope.exposeContainer.value = _.range(intModel.percentOfExposed / 5 + 1);
        $scope.exposeContainer.selectedValue = intModel.percentOfExposed;
        $scope.exposeContainer.progress.exposed = progress.exposed;
        $scope.exposeContainer.progress.notExposed = progress.notExposed;
        $scope.exposeContainer.progress.total = progress.exposed + progress.notExposed;

        vm.invalidateInOutCounts(intModel.requiredStartsCount, intModel.percentOfExposed);
        vm.loaded = true;
      });
    };

    var prepopulateInterception = function(){
      var pid = window.ICS_CONFIG.sampleId;
      var id = pid.substr(1, pid.length);
      CampaignService.get({id : id}, function(campaign){
        $scope.interception.name = "Interception for - " + campaign.name;
        $scope.interception.codes = [{
          id: campaign.pid,
          code: campaign.cid,
          name: campaign.name,
          codeType: 1
        }];
        vm.loaded = true;
      });
    };

    if (window.ICS_CONFIG.sampleId > 0){
      loadInterception();
    } else if (window.ICS_CONFIG.sampleId.length > 0 && window.ICS_CONFIG.sampleId[0] == 'p') {
      prepopulateInterception();
    } else {
      vm.loaded = true;
    }

    vm.cancel = function(){
      vm.redirected = true;
    }

    vm.save = function() {
      vm.saveDisabled = true;

      var def = jQuery.Deferred();
      $scope.interception.percentOfExposed = $scope.exposeContainer.selectedValue;
      if ($scope.interception.id == null){
        Interceptions.add({id : window.ICS_CONFIG.accountId}, $scope.interception, function(response){
          def.resolve();
        });
      } else {
        Interceptions.update({id : window.ICS_CONFIG.accountId}, $scope.interception, function(response){
          def.resolve();
        });
      }

      def.done(function(){
        vm.redirected = true;
        window.location.assign("/ics")
      });
    };

    vm.openAddCodes =function(){
      ModalService
        .showModal(({
          templateUrl: `../../assets/js/app/interception/modal/manageCodes.html?v=${window.BUILD_VERSION}`,
          controller: "ManageInterceptionCodesController",
          controllerAs: "icsm",
          inputs:{
            model: $scope.interception.codes
          }
        })).then(function(modal){
          modal.element.modal();
          modal.close.then(function (result) {
            if (result){
              $scope.interception.codes = result;
            }
          });
        });
    };

    vm.removeCode = function(code){
      $scope.interception.codes = $scope.interception.codes.filter(function(c) {return !_.isEqual(c, code)});
    };

    // prevents the user from instantly leaving the page if they have unsaved changes
    $window.addEventListener("beforeunload", function (event) {
      if (vm.redirected) return;

      var isEqual = angular.equals($scope.origInterception, $scope.interception);
      if (isEqual == false) {
        (event || $window.event).returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
      }
    });
  }
})();
